import { createSelector } from 'reselect'

import { AppState } from '@/ducks/app/slices/app.slice'

const selectApp = (state: { app: AppState }) => state.app

export const selectIsAppInitialized = createSelector(
  selectApp,
  app => app.isInitialized
)

export const selectAppSettings = createSelector(selectApp, app => app.settings)

export const selectIsSidebarOpen = createSelector(
  selectApp,
  app => app.isSidebarOpen
)

export const selectFlags = createSelector(selectApp, app => app.flags)

export const selectNotificationAppId = createSelector(
  selectApp,
  app => app.notificationAppId
)

export const selectPendingOrdersIds = createSelector(
  selectApp,
  app => app.pendingOrderIds
)
export const selectHasUserInteracted = createSelector(
  selectApp,
  app => app.hasUserInteracted
)
